import { AlertTriangle } from "lucide-react";
import type { ReactNode } from "react";

import { Button } from "./button";

interface EmptyStateProps {
  title: string;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: ReactNode;
}

export function EmptyState({
  title,
  message,
  actionLabel,
  onAction,
  icon,
}: EmptyStateProps) {
  return (
    <div className="text-center py-12">
      {icon ?? (
        <AlertTriangle size={48} className="mx-auto text-gray-400 mb-4" />
      )}
      <h2 className="text-gray-600 mb-4">{title}</h2>
      <p className="text-gray-500 mb-6">{message}</p>
      {actionLabel && onAction && (
        <Button onClick={onAction}>{actionLabel}</Button>
      )}
    </div>
  );
}
